module.exports = __webpack_public_path__ + "img/village_des_benjamins.16db113a.png";